import React, { useState } from "react"
import { getIcon } from "../../../../utils/iconConfig"
import Image from "../../../../assets/images/default-img.jpg"
import "./RestrictedStyle.css"
import ImageModal from "../../modals/imageModal/ImageModal"

const RestrictedCard = ({ data, index, allData }) => {
  const [currentIndex, setCurrentIndex] = useState(
    allData?.findIndex((item) => item?.styleNumber === data?.styleNumber)
  )
  const [imageModal, setImageModal] = useState({
    isOpen: false,
    imgUrl: null,
    styleNumber: null,
    allData: null,
  })

  const isFirstItem = currentIndex === 0
  const isLastItem =
    currentIndex === allData?.length - 1 || allData?.length === 0

  const handleNextClick = () => {
    if (currentIndex < allData?.length - 1) {
      const newIndex = currentIndex + 1
      setCurrentIndex(newIndex)
      const nextItem = allData[newIndex]

      setImageModal({
        isOpen: true,
        imgUrl: nextItem?.imageUrl || null,
        styleNumber: nextItem?.styleNumber,
        allData: nextItem,
      })
    }
  }

  const handlePrevClick = () => {
    if (currentIndex > 0) {
      const newIndex = currentIndex - 1
      setCurrentIndex(newIndex)
      const prevItem = allData[newIndex]

      setImageModal({
        isOpen: true,
        imgUrl: prevItem?.imageUrl || null,
        styleNumber: prevItem?.styleNumber,
        allData: prevItem,
      })
    }
  }

  const handleOpenImageModal = (data) => {
    setImageModal({
      isOpen: true,
      imgUrl: data?.imageUrl,
      styleNumber: data?.styleNumber,
      allData: data,
    })
  }

  const handleCloseImageModal = () => {
    setImageModal({
      isOpen: false,
      imgUrl: null,
      styleNumber: null,
      allData: null,
    })
  }
  return (
    <>
      <div className="restrict-card">
        <div className="left-section">
          <p>{index + 1}.</p>
          <div>
            <span
              style={{
                height: "0.8vw",
                width: "0.8vw",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}>
              {getIcon(data?.designClass)}
            </span>
            <p>{data?.styleNumber}</p>
          </div>
        </div>
        <img
          className="right-section"
          src={data?.transformedImageUrl || Image}
          alt=""
          srcset=""
          style={{
            cursor: "pointer",
          }}
          onClick={() => handleOpenImageModal(data)}
        />
      </div>
      <ImageModal
        openModal={imageModal.isOpen}
        handleClose={handleCloseImageModal}
        data={imageModal}
        nextClick={handleNextClick}
        prevClick={handlePrevClick}
        hasNext={!isLastItem}
        hasPrev={!isFirstItem}
      />
    </>
  )
}

export default RestrictedCard
